import { render } from "./NavbarHeaderComponent.vue?vue&type=template&id=448f2b18&scoped=true&ts=true"
import script from "./NavbarHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarHeaderComponent.vue?vue&type=script&lang=ts"

import "./NavbarHeaderComponent.vue?vue&type=style&index=0&id=448f2b18&scoped=true&lang=css"

import exportComponent from "G:\\MD\\MyFiles\\Work\\Projects\\OshElektro\\SMVueJS\\smv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448f2b18"]])

export default __exports__